import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SectorInsightsList } from './SectorInsightsList';
import { SectorInsightsDetail } from './SectorInsightsDetail';
import { DEFAULT_INSIGHTS_TAB, type SectorInsightsTabId } from './types';
import '../PendingCAEvents/pendingCa.css';
import '../SectorIntelligence/sectorIntel.css';
import '../SectorTaxonomy/sectorTaxonomy.css';

// 라우트: /sectors/insights
//   - ?canonical=<key>  → 상세 화면
//   - ?canonical=<key>&tab=stocks|sources  → 탭 선택
//   - canonical 없음    → 리스트 화면
export default function SectorInsightsPage(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams();
  const canonicalKey = searchParams.get('canonical')?.trim() || null;
  const tabParam = searchParams.get('tab') as SectorInsightsTabId | null;
  const tab: SectorInsightsTabId =
    tabParam === 'stocks' || tabParam === 'sources' ? tabParam : DEFAULT_INSIGHTS_TAB;

  const goDetail = useCallback(
    (key: string) => {
      const next = new URLSearchParams(searchParams);
      next.set('canonical', key);
      if (!next.get('tab')) next.set('tab', DEFAULT_INSIGHTS_TAB);
      setSearchParams(next, { replace: false });
    },
    [searchParams, setSearchParams]
  );

  const goBack = useCallback(() => {
    const next = new URLSearchParams(searchParams);
    next.delete('canonical');
    next.delete('tab');
    setSearchParams(next, { replace: false });
  }, [searchParams, setSearchParams]);

  const onTabChange = useCallback(
    (nextTab: SectorInsightsTabId) => {
      const next = new URLSearchParams(searchParams);
      next.set('tab', nextTab);
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  return (
    <div className="pca-page">
      {canonicalKey ? (
        <SectorInsightsDetail
          canonicalKey={canonicalKey}
          tab={tab}
          onBack={goBack}
          onTabChange={onTabChange}
        />
      ) : (
        <SectorInsightsList onRowClick={goDetail} />
      )}
    </div>
  );
}
